var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 225",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5,0,0,1.5,-1170,-540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830,360C857.596,360 880,382.404 880,410C880,437.596 843.333,510 830,510C816.667,510 780,437.596 780,410C780,382.404 802.404,360 830,360ZM830,383.333C815.282,383.333 803.333,395.282 803.333,410C803.333,424.718 815.282,436.667 830,436.667C844.718,436.667 856.667,424.718 856.667,410C856.667,395.282 844.718,383.333 830,383.333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIco);
export default __webpack_public_path__ + "static/media/location-ico.12c3ef799e783144b19be7af9d2f7a46.svg";
export { ForwardRef as ReactComponent };